const ModalVideo = function()
{

    const boxVideo = function (el, status) {
        var iframeyt = $("#video-yt");
        var videoYT = el;

        
        if (status == 1) {
            iframeyt.attr('src', '');
        } else {
            var videosrc = videoYT.attr('data-src');
            var timToPlay = 0;

            if(videosrc.indexOf('start=')){
                timToPlay = videosrc.split('start=')[1];
            }
            if(videosrc.indexOf('t=')){
                timToPlay = videosrc.split('t=')[1];
            }

            timToPlay = parseInt(timToPlay);
            iframeyt.attr('src', "https://www.youtube.com/embed/" + YouTubeGetID(videosrc) + "?start="+timToPlay+"&rel=0&autoplay=1");
        }

        var $modalSearch = $("#modal-video");
        $modalSearch.fadeToggle(200);
    }

    const YouTubeGetID = function(url) {
        url = url.split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
        return (url[2] !== undefined) ? url[2].split(/[^0-9a-z_\-]/i)[0] : url[0];
      }
    
    const closeModal = function (el) {

            console.log(el);

        if (el.attr('data-modal') == "modal") {
    
            el.closest('.elm-modal').fadeOut(100);
    
        } else {
            boxVideo(el,1);// close video
        }
    }

    return {
        init : function () {

            $(document).on("click", ".playBtn", function(){
                boxVideo( $(this) )
            });
            $(document).on("click", ".s-close", function(){
                console.log('s-close');
                closeModal( $(this) );
            });
        }
    }

}();

module.exports = ModalVideo;